// Centralized date-fns locale imports for ESM compatibility
import { type Locale } from 'date-fns';
import { da, de, enAU, enCA, enGB, enIN, enNZ, enUS, enZA, es, fr, it, nl, pt, ptBR, sv } from 'date-fns/locale';

// `satisfies` rather than a `Record<string, Locale>` annotation: consumers compile this package from
// source under THEIR tsconfig, and `@cx-sdk/typescript-config` sets `noUncheckedIndexedAccess`, under
// which an index signature makes every `locales.enAU` in repubs.ts `Locale | undefined`.
export const locales = {
  da,
  de,
  enAU,
  enCA,
  enGB,
  enIN,
  enNZ,
  enUS,
  enZA,
  es,
  fr,
  it,
  nl,
  pt,
  ptBR,
  sv,
} satisfies Record<string, Locale>;
